import { render, staticRenderFns } from "./Corsi.vue?vue&type=template&id=15644dd2&scoped=true&"
import script from "./Corsi.vue?vue&type=script&lang=js&"
export * from "./Corsi.vue?vue&type=script&lang=js&"
import style0 from "./Corsi.vue?vue&type=style&index=0&id=15644dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15644dd2",
  null
  
)

export default component.exports